import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeCrmComponent} from './home-crm/home-crm.component';
import {DashboardCrmComponent} from './dashboard-crm/dashboard-crm.component';
import {CustomersComponent} from './pages/customers/customers.component';
import {CommonModule} from '@angular/common';
import {TasksComponent} from './pages/tasks/tasks.component';
import {UserAreaCrmGuard} from '@app/guards/user-area/user-area-crm-guard.service';
import {CrmSection} from '@enum/crm-section';
import {CrmMessagesComponent} from './pages/crm-messages/crm-messages.component';
import {CrmClaimsPageComponent} from './pages/crm-claims-page/crm-claims-page.component';
import {listWithDetailParamMatcher} from '../shared/utils/list.detail.param.matcher';
import {CrmPreferencesComponent} from './pages/crm-preferences/crm-preferences.component';


const routes: Routes = [
  {
    path: '',
    component: HomeCrmComponent,
    children: [
      {path: '', component: DashboardCrmComponent},
      {
        path: 'customers',
        children: [
          {
            path: 'lead',
            component: CustomersComponent,
            data: {section: CrmSection.Lead},
            canActivate: [UserAreaCrmGuard]
          },
          {
            path: 'verified-contacts',
            component: CustomersComponent,
            data: {section: CrmSection.VerifiedContact},
            canActivate: [UserAreaCrmGuard]
          },
          {
            path: 'contact-list',
            component: CustomersComponent,
            data: {section: CrmSection.CustomerList},
            canActivate: [UserAreaCrmGuard]
          },
          {path: '**', redirectTo: 'lead'},
        ],
        data: {sections: [CrmSection.Lead, CrmSection.VerifiedContact, CrmSection.CustomerList]},
        canActivate: [UserAreaCrmGuard]
      },
      {
        path: 'tasks', children: [
          {path: 'my-tasks', component: TasksComponent, data: {matTabIndex: 0}},
          {path: 'assigned', component: TasksComponent, data: {matTabIndex: 1}},
          {path: 'completed', component: TasksComponent, data: {matTabIndex: 2}},
          {path: '**', redirectTo: 'my-tasks'},
        ],
        data: {section: CrmSection.SalesTasks},
        canActivate: [UserAreaCrmGuard]
      },
      {
        path: 'messages', children: [
          {path: 'new-messages', component: CrmMessagesComponent, data: {matTabIndex: 0}},
          {path: 'read-messages', component: CrmMessagesComponent, data: {matTabIndex: 1}},
          {path: 'my-messages', component: CrmMessagesComponent, data: {matTabIndex: 2}},
          {path: '**', redirectTo: 'new-messages'},
        ],
        data: {section: CrmSection.Messages},
        canActivate: [UserAreaCrmGuard]
      },
      {
        matcher: (url) => listWithDetailParamMatcher(url, {
          listRoute: 'claims',
          singleRoute: 'claim',
          paramName: 'id'
        }),
        component: CrmClaimsPageComponent,
        data: {section: CrmSection.Claims},
        canActivate: [UserAreaCrmGuard]
      },
      {
        path: 'preferences', children: [
          {path: 'mail-templates', component: CrmPreferencesComponent, data: {matTabIndex: 0}},
          {path: 'signature', component: CrmPreferencesComponent, data: {matTabIndex: 1}},
          {path: '**', redirectTo: 'mail-templates'},
        ],
        data: {section: CrmSection.Preferences},
        canActivate: [UserAreaCrmGuard]
      },
      {path: '**', component: DashboardCrmComponent},
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), CommonModule],
  exports: [RouterModule]
})
export class CrmRoutingModule {
}
